import React, { Component } from 'react'
import {
  Modal,
  Button
} from 'react-bootstrap'

import { connect } from 'react-redux'
import { hideModalSinCupo } from '../../actions'

class ModalSinCupo extends Component {
  render () {
    const {
      numero,
      show
    } = this.props

    return (
      <div>
        <Modal show={show} size='sm'>
          <Modal.Header>
            <h3>Atención</h3>
          </Modal.Header>
          <Modal.Body>
            {numero ? `La carta número ${<strong>{numero}</strong>} no tiene cupo. `
              : `Código de cupo incorrecto. `} No puede ingresar.
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.props.hideModalSinCupo()}>
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  show: state.camionesIngreso.iCompletoShowSinCupo
})

const withRedux = connect(mapStateToProps, { hideModalSinCupo })
export default withRedux(ModalSinCupo)
